import { httpClient } from "src/shared/services/httpClient";
import { AxiosResponse } from "axios";
import { ParametricType } from "src/shared/types";

export const registerN01User = (data: FormData) => {
  return httpClient.post("/welcomeNonGemi/registerReact", data);
};

export const getCountries = () =>
  httpClient.get("/welcomeNonGemi/getCountriesJson");

export const getValidationEmail = (token: string) =>
  httpClient.get(`/welcomeNonGemi/validateEmail?t=${token}`);

export const getIdentityTypesForNonGemiRegistration = (): Promise<
  AxiosResponse<ParametricType[]>
> => httpClient.get("/welcomeNonGemi/getIdentityTypesForNonGemiRegistration");
